export default __webpack_public_path__ + "static/media/injection.658680f3.svg";